var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GameConfirmPanel box-panel-float"},[_c('div',{staticClass:"box-panel-float-info"},[_c('div',{staticClass:"bx-close",on:{"click":_vm.cancel}}),_c('div',{staticClass:"bx-confirm",on:{"click":_vm.confirm}})])])}
var staticRenderFns = []

export { render, staticRenderFns }